/** Value portion of chart bracket label, e.g. "1 yr" or "5 yrs". */
export const formatYearsSoonerShortValueLine = (deltaYears: number): string => {
  const unit = deltaYears === 1 ? "yr" : "yrs";
  return `${deltaYears} ${unit}`;
};

/** Format year delta for chart bracket (short) and payoff banner (long). */
export const formatYearsSoonerShort = (deltaYears: number): string =>
  `${formatYearsSoonerShortValueLine(deltaYears)} sooner`;

export const formatYearsSoonerLong = (deltaYears: number): string => {
  const unit = deltaYears === 1 ? "year" : "years";
  return `${deltaYears} ${unit} sooner with Ed`;
};

export const formatMonthsLongerLong = (deltaMonths: number): string => {
  const unit = deltaMonths === 1 ? "month" : "months";
  return `${deltaMonths} ${unit} longer with Ed`;
};

export const formatMonthsSoonerLong = (deltaMonths: number): string => {
  const unit = deltaMonths === 1 ? "month" : "months";
  return `${deltaMonths} ${unit} sooner with Ed`;
};

export const formatHomeBudgetExtensionLong = (formattedDelta: string): string =>
  `Ed extends budget by ${formattedDelta} for a larger home`;

export const formatLongTermGainPayoffTitle = (
  formattedGain: string,
  years: number,
): string => `${formattedGain} more in ${years} years, hands-off`;

export const resolveDebtPayoffTitle = (
  deltaYears: number | null | undefined,
  deltaMonths: number | null | undefined,
  fallback: string,
): string => {
  if (typeof deltaYears === "number" && deltaYears > 0) {
    return formatYearsSoonerLong(deltaYears);
  }
  if (
    typeof deltaYears === "number" &&
    deltaYears === 0 &&
    typeof deltaMonths === "number" &&
    deltaMonths > 0
  ) {
    return formatMonthsSoonerLong(deltaMonths);
  }
  if (typeof deltaYears === "number" && deltaYears === 0) {
    return fallback;
  }
  if (typeof deltaMonths === "number" && deltaMonths >= 12) {
    return formatYearsSoonerLong(Math.round(deltaMonths / 12));
  }
  if (typeof deltaMonths === "number" && deltaMonths > 0) {
    return formatMonthsSoonerLong(deltaMonths);
  }
  return fallback;
};
